import cn from 'classnames'
import {FC, ReactNode} from 'react'

import {theme} from '@/theme/theme'

type ComparisonTableProps = {
  header: ReactNode
  isCentered?: boolean
}

export const ComparisonTable: FC<React.PropsWithChildren<ComparisonTableProps>> = ({
  header,
  isCentered = false,
  children,
}) => (
  <>
    <table className={cn('comparison-table', isCentered && 'centered')}>
      <thead>{header}</thead>
      <tbody>{children}</tbody>
    </table>

    <style jsx global>{`
      .comparison-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        table-layout: fixed;
      }
      .comparison-table thead th {
        border-bottom: 3px solid ${theme.palette.gray[200]};
        padding: ${theme.spacing[4]} 0;
      }
      .comparison-table tbody td {
        padding: ${theme.spacing[4.5]} 0;
      }
      .comparison-table thead th + th,
      .comparison-table tbody td + td {
        padding-left: ${theme.spacing[5]};
      }
      .comparison-table tr + tr {
        border-top: 1px solid ${theme.palette.gray[200]};
      }
      .comparison-table th,
      .comparison-table td {
        width: 60%;
      }
      .comparison-table th:nth-child(2),
      .comparison-table td:nth-child(2) {
        width: 40%;
      }
      .comparison-table tbody tr:last-child td {
        padding-bottom: 0;
      }
      .centered {
        text-align: center;
      }
      /* Column headers that carry no visible text still need a name for the data cells to be
         associated with, which is what axe's td-has-header checks. */
      .comparison-table .visually-hidden {
        position: absolute;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }
    `}</style>
  </>
)
